import { render, staticRenderFns } from "./MyPayrroll.vue?vue&type=template&id=95cb020e&"
import script from "./MyPayrroll.vue?vue&type=script&lang=js&"
export * from "./MyPayrroll.vue?vue&type=script&lang=js&"
import style0 from "./MyPayrroll.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports